var DrawerMenu_module_default = {
	bg: "_bg_610zp_8",
	drawer: "_drawer_610zp_17",
	body: "_body_610zp_51"
};
//#endregion
export { DrawerMenu_module_default as default };

//# sourceMappingURL=DrawerMenu.module.js.map